<template>

  <!-- Page Sidebar Ends-->
  <div class="page-body">
  
    <PageTitle   title="Tank Survey" path="frontdash" />
    <!-- Container-fluid starts-->
    <div class="container-fluid" v-show='!isCapture && !isLocation' ref="surveyContainer">
      <div class="row size-column">

        <div class="col-xxl-9 box-col-12">
               <div class="card ">  
                    <div class="card-body">  
                  <div class="row">
                   
                
             <div class="col-xl-6 col-sm-12 col-12" >
                <label class="form-label"><span class="f-w-500 f-14">1)मालमत्ताधारकाचे नाव</span></label>
                <input class="form-control" type="text" v-model="tank.name" >
            </div>  
                        
            <div class="col-xl-6 col-sm-12 col-12"   >
                 <label class="form-label"><span class="f-w-500 f-14">2)वॉर्ड नं. (Ward No)</span></label>
                  <input class="form-control" type="number" v-model="tank.ward" > 
              </div>
            <div class="col-xl-6 col-sm-12 col-12"   >
                <label class="form-label"><span class="f-w-500 f-14">3)घर क्रमांक ( Property Number)</span></label>
                   <input class="form-control" type="text" v-model="tank.property" >
                 
                <!--<input class="form-control" type="text" v-model="tank.comman_name" >-->
            </div>
            <div class="col-xl-6 col-sm-12 col-12"   >
                <label class="form-label"><span class="f-w-500 f-14">4)फोन नंबर (Phone Number)</span></label> 
                  <input class="form-control" type="number" v-model="tank.phone" >
                 <!--<input class="form-control" type="text" v-model="tank.botnical_name" >  -->
            </div>
            <div class="col-xl-6 col-sm-12 col-12"   >
                <label class="form-label"><span class="f-w-500 f-14">5)पत्ता(Address)</span></label>
                <input class="form-control" type="text" v-model="tank.address" >
            </div>
            <div class="col-xl-6 col-sm-12 col-12"   >
                <label class="form-label"><span class="f-w-500 f-14">6)Tank Location</span></label>
                <button @click="getLocation"  class=" badge bg-primary">Get Location</button>
                <input  class="form-control" type="text" v-model="tank.tank_location_lat" >
              
                <div id="locError" class="text-danger"></div>
                
            </div>
            
            <!-- New Marathi Fields -->
            <div class="col-xl-12 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">आपल्याकडील सांडपाणी कुठे सोडले जाते</span></label>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="tank.wastewater_disposal.septic_tank" id="septic_tank">
                    <label class="form-check-label" for="septic_tank">सेप्टिक टाकीमध्ये</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="tank.wastewater_disposal.open_area" id="open_area">
                    <label class="form-check-label" for="open_area">उघड्या जागेवर</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="tank.wastewater_disposal.drain" id="drain">
                    <label class="form-check-label" for="drain">गटार मध्ये</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="tank.wastewater_disposal.other" id="other_wastewater">
                    <label class="form-check-label" for="other_wastewater">इतर</label>
                </div>
            </div>
            
            <div class="col-xl-6 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">टाकीला जोडलेली एकूण शौचालयांची संख्या</span></label>
                <input class="form-control" type="number" v-model="tank.toilet_count" placeholder="शौचालयांची संख्या">
            </div>
            
            <div class="col-xl-6 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">टाकीची क्षमता (लिटर / m³)</span></label>
                <input class="form-control" type="text" v-model="tank.tank_capacity" placeholder="क्षमता">
            </div>
            
            <div class="col-xl-12 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">शौचालय स्वच्छ भारत अभियान अनुदानातून बांधले आहे का?</span></label>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.swachh_bharat_grant" value="Yes" id="grant_yes">
                    <label class="form-check-label" for="grant_yes">होय</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.swachh_bharat_grant" value="No" id="grant_no">
                    <label class="form-check-label" for="grant_no">नाही</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.swachh_bharat_grant" value="Don't Know" id="grant_dont_know">
                    <label class="form-check-label" for="grant_dont_know">माहित नाही</label>
                </div>
            </div>
            
            <div class="col-xl-12 col-sm-12 col-12" style="display:none">
                <label class="form-label"><span class="f-w-500 f-14">टाकीचा प्रकार</span></label>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.tank_type" value="Single Chamber" id="single_chamber">
                    <label class="form-check-label" for="single_chamber">सिंगल चेंबर</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.tank_type" value="Double Chamber" id="double_chamber">
                    <label class="form-check-label" for="double_chamber">डबल चेंबर</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.tank_type" value="Multi Chamber" id="multi_chamber">
                    <label class="form-check-label" for="multi_chamber">मल्टी चेंबर</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.tank_type" value="Other" id="other_tank_type">
                    <label class="form-check-label" for="other_tank_type">इतर</label>
                </div>
            </div>
            
            <div class="col-xl-12 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">सेप्टिक टाकी सोकपिटला जोडले आहे का?</span></label>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.soak_pit_connected" value="Yes" id="soak_pit_yes">
                    <label class="form-check-label" for="soak_pit_yes">होय</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.soak_pit_connected" value="No" id="soak_pit_no">
                    <label class="form-check-label" for="soak_pit_no">नाही</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="radio" v-model="tank.soak_pit_connected" value="Don't Know" id="soak_pit_dont_know">
                    <label class="form-check-label" for="soak_pit_dont_know">माहित नाही</label>
                </div>
            </div>
            
            <div class="col-xl-6 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">टाकीचे बांधकाम वर्ष</span></label>
                <input class="form-control" type="number" v-model="tank.construction_year" placeholder="वर्ष" min="1900" :max="new Date().getFullYear()">
            </div>
            
            <div class="col-xl-6 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">टाकी रिकामी केलेला दिनांक (शेवटचा वेळ)</span></label>
                <input class="form-control" type="date" v-model="tank.last_emptied_date">
            </div>
            
            <div class="col-xl-12 col-sm-12 col-12">
                <label class="form-label"><span class="f-w-500 f-14">टाकीबद्दल इतर माहिती</span></label>
                <textarea class="form-control" v-model="tank.additional_info" rows="3" placeholder="अतिरिक्त माहिती"></textarea>
            </div> 
           
             <div class="col-xl-6 col-sm-12 col-12"   >
                <label class="form-label"><span class="f-w-500 f-14">11) Tank Image</span></label><br>
                <img  v-if="tank.image && tank.image!=''" :src="tank.image" @click="caputureImage()" width="100"/>
               <img  v-else  src="../../assets/img_upload.png" width="100" @click="caputureImage()"/>  
            </div>
            
            
            
            
            
            
            
            
            
            
            
            
              
          </div>
            </div>
              <div class="card-footer">  
              <div class="mb-2">
                  <h6 v-show="!isOnline" class="text-danger">You Are Offline,Data will be saved locally.</h6>
              </div>
                <div class="col-12">
                        <button class="btn btn-primary" @click="save_survey">Submit Survey</button>
                        &nbsp;&nbsp; <button class="btn btn-danger" @click="clear_survey">Clear Inputs</button>
                    </div>
                    <div class="text-info" id="process_lbl"></div>
            </div>
            
            
                 </div>
                 </div>
      </div>
      </div>
   
    
  <CaptureImage v-if='isCapture' @backBtn="backBtn" @setImage="setImage"/>
  <!--<WebcamCapture v-if='isCapture' @backBtn="backBtn" @setImage="setImage"/>-->
  <!--<LocationPicker v-show='isLocation' @backBtnLoc="backBtnLoc" @setLocation="setLocation" :last_pins="last_pins" :userDetails="userDetails"/>-->
                <div :class="(isLocation)?'show':'hide'" >
                        <LocationPicker @backBtnLoc="backBtnLoc" @setLocation="setLocation" :last_pins="last_pins" :userDetails="userDetails"/>
                </div>
  </div>
</template>
<style scooped>
    .form-control{
                margin-bottom: 15px;
                padding: 1px 7px !important;
                border-color: black;
    }
    .select2-container .select2-selection--single{
        height: 30px !important;
         padding:  1px 7px !important;
    }
    .hide{
        display: none;
    }
    .show{
        display: block;
    }
    
</style>
<script>
import PageTitle from '@/components/PageTitle.vue';
import axios from 'axios';
import WebcamCapture from '@/components/WebcamCapture.vue';
import LocationPicker from '@/components/LocationPicker.vue';
import CaptureImage from '@/components/CaptureImage.vue';
import {   addVeng_TankRecord } from '@/dexie';
import { ref, onMounted } from 'vue';

export default {
  name: 'TankSurveyVengurla',
  components: {
        PageTitle ,WebcamCapture,LocationPicker,CaptureImage,addVeng_TankRecord
    },
    beforeRouteLeave(to, from, next) {
            
            this.isLocation=0;
            this.isCapture=0;
            next();
    },
    computed:{
            showSection(){
                return  this.showCreateSection;
                }
        },
      mounted() {
            if (this.$route.query.q) {
                this.getSurveyQues(this.$route.query.q);
            }else {
                
                        this.getBasics();
                  
            }
           
        }, 
        data() {
        return { 
          tank: {
            'iddate':this.today(),
            'byuser':'',
            'tank_image':'',
            'name':'',
            'ward':'',
            'property':'',
            'phone':'',
            'address':'',
            'tank_location_lat':'',
            'tank_location_lng':'',
            'wastewater_disposal': {
              'septic_tank': false,
              'open_area': false,
              'drain': false,
              'other': false
            },
            'toilet_count': '',
            'tank_capacity': '',
            'swachh_bharat_grant': '',
            'tank_type': '',
            'soak_pit_connected': '',
            'construction_year': '',
            'last_emptied_date': '',
            'additional_info': ''
          }, 
          survey_details: {name:''},
          isCapture:false,
          isLocation:false,
          isSubmitted:false,
          
          
          
          
          tanknames:[],
          tankbotnical_name:[],
          last_pins:[],
          prev_details:{'society_name':'','road_name':''},
          userDetails:{'kmlurl':''},
          isDataLoaded:false ,
          location:{
                latitude: 18.57094038048649,
                longitude: 73.81621311358407
          },
          isOnline:  navigator.onLine, // Initial status
        }
    },
     beforeUnmount() {
    // Clean up event listeners
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  setup(){
       
    const newRecord = ref({ token: '', data: '' });  
    
         const loadtankRecords = async () => {
           const data_here= await getAlltanks();
               if(data_here.length>0){
                    //self.tanknames  = data_here[0].data;
                    for (var i = 0; i < data_here[0].data.length; i++) {
                        console.log(data_here[0].data[i]);
                    }
               }
     }
     
  }, 
    methods: {
        today(){
            var today = new Date()
            var month=today.getMonth()+1;
            var day=today.getDate();
            
            var hr=today.getHours();
            var min=today.getMinutes();
            var sec=today.getSeconds();
            
            var now_date = (today.getFullYear() + '-' + ((month<10)?'0'+month:month) + '-' + ((day<10)?'0'+day:day));//today.getDate());
            var now_time = (((hr<10)?'0'+hr:hr) + ":" +((min<10)?'0'+min:min) + ":" + ((sec<10)?'0'+sec:sec) ).toString();
            
            return now_date+' '+now_time;
        },
         updateOnlineStatus() {
          this.isOnline = navigator.onLine;
        },
        clear_survey(){
            var self=this;
           
             self.tank={
               'iddate':self.today(),
               'byuser':'',
               'tank_image':'',
               'name':'',
               'ward':'',
               'property':'',
               'phone':'',
               'address':'',
               'tank_location_lat':'',
               'tank_location_lng':'',
               'wastewater_disposal': {
                 'septic_tank': false,
                 'open_area': false,
                 'drain': false,
                 'other': false
               },
               'toilet_count': '',
               'tank_capacity': '',
               'swachh_bharat_grant': '',
               'tank_type': '',
               'soak_pit_connected': '',
               'construction_year': '',
               'last_emptied_date': '',
               'additional_info': ''
             };
           
                                          
                                          
             
             this.isSubmitted=false;
             
            if(this.prev_details.society_name)
                this.tank.society_name=this.prev_details.society_name;
            
            if(this.prev_details.road_name)
             this.tank.road_name=this.prev_details.road_name;
             
        },
     async save_survey() {
          
          if(!this.isSubmitted || this.isSubmitted){  // for double upload
              this.isSubmitted=true;
              if(this.tank.name.length==0)
                  this.$swal("Please Enter Name.");
              else{
                // $(".loader-wrapper").show(); 
                
                $("#process_lbl").html("Saving In Background");
                
                    var self = this;
                             const blob = (this.tank.image)?self.dataURLtoBlob(this.tank.image):null;
                                    
                    //07.09.2024
                    if(this.isOnline){//11.09.2024
                            self.prev_details.society_name=self.tank.society_name;
                            self.prev_details.road_name=self.tank.road_name;
                            
                            localStorage['latLong']=self.tank.tank_location_lat;
                            
                                 
                                const formData = new FormData();
                                if(blob)
                                    formData.append('image', blob, 'captured_photo.png'); 
                                else
                                    formData.append('image', ''); 
                                
                                formData.append('ques', JSON.stringify(self.tank)); 
                                
                                
                            await axios.post('saveTankSurveyVengurla',formData).then(function (response) {
                               
                               //self.$swal(response.data.msg);
                                $("#process_lbl").html(response.data.msg);
                                
                               self.surveys  = response.data.surveys ;   
                              //  $(".loader-wrapper").hide();
                               
                              //  window.scrollTo(0, 0);
                            }).catch(async (error) => { 
                                   if (error) {
                                       console.log(error)
                                           //  $(".loader-wrapper").hide();
                                       
                                       if(!navigator.onLine){
                                           const id = await addVeng_TankRecord({ token:localStorage['token'], data: JSON.stringify(self.tank),blob:blob });
                                             if(id>0){
                                                  self.$swal("Data Saved Offline");
                                                  self.isSubmitted=false;
                                             }
                                             else{
                                                    self.$swal("Failed To Save Offline");
                                                    self.isSubmitted=false;
                                             }  
                                       }
                                        else if(error.response){
                                            self.$swal("Please Fill Required Data");
                                        }
                                    //   if(!error.response){
                                    //       self.tank.iddate=this.today();
                                    //          const id = await addSurveyRecord({ token:localStorage['token'], data: JSON.stringify(self.tank),blob:blob });
                                    //          if(id>0){
                                    //                  $("#process_lbl").html(self.tank.iddate+") Data Saved Offline");//self.$swal("Data Saved Offline");
                                    //               this.isSubmitted=false;
                                    //          }
                                    //          else{
                                    //                   $("#process_lbl").html("Failed To Save Offline");//self.$swal("Failed To Save Offline");
                                    //                 this.isSubmitted=false;
                                    //          }      
                                    //                  $(".loader-wrapper").hide();
                                    //   }
                                   }  
                              });
                    }else{
                        // alert(localStorage['token']);
                      const id = await addVeng_TankRecord({ token:localStorage['token'], data: JSON.stringify(self.tank),blob:blob });
                         if(id>0){
                              self.$swal("Data Saved Offline");
                              this.isSubmitted=false;
                         }
                         else{
                                self.$swal("Failed To Save Offline");
                                this.isSubmitted=false;
                         }      
                                // $("#process_lbl").html("Please Connect To Internet");
                                // self.$swal("Please Connect To Internet");
                               //  $(".loader-wrapper").hide();
                                 
                                 
                    }
              }
          }
        },
        setRadio(what,item){
            item.ans=what;
        },
        
        setImage(value){ 
            this.tank.image=value;
             this.isCapture=false; 
             this.scrollToBottom();
        },
        
        
        scrollToBottom(){
                  this.$nextTick(() => {
                    const container = this.$refs.surveyContainer;
                    if (container) {
                      container.scrollTop = container.scrollHeight;
                    }
                  });
        },
        backBtn(){  
             this.isCapture=false;
        },
        caputureImage(){
            this.isCapture=true;
        },
       
     async  getBasics() {
            var self = this;
           
           if(this.isOnline){
                    axios.post('getReportBasics',{location:this.location}).then(function (response) {
                        self.tanknames  = response.data.tanknames ;     
                        self.last_pins  = response.data.last_pins ;    
                        self.userDetails=response.data.userdetails;
                        
                        self.tank.society_name=response.data.last_survey.society_name;     
                        self.tank.road_name=response.data.last_survey.road_name;     
                        
                        self.prev_details.society_name=self.tank.society_name;
                        self.prev_details.road_name=self.tank.road_name;
                       
                        // cleartanks();
                       // addtankRecord({ data: JSON.stringify(self.tanknames) });
                       // window.scrollTo(0, 0);
                    }).then(()=>{
                                  $("#tank_names").select2().on('change', function (event) {
                                      
                                    const selectedProduct = self.tanknames.find(item => item.marathi_name === event.target.value);
                                      if (selectedProduct) {
                                          self.tank.local_name= selectedProduct.marathi_name; 
                                          self.tank.comman_name= selectedProduct.hindi_name;
                                          //self.tank.other_name= selectedProduct.english_name; 
                                          self.tank.botnical_name= selectedProduct.botnical_name; 
                                          
                                          $("#b_tank_names").val(self.tank.botnical_name).select2();
                                          $("#c_tank_names").val(self.tank.comman_name).select2(); 
                                      }
                                    
                            }); 
                            
                            
                               $("#b_tank_names").select2().on('change', function (event) {
                                      
                                    const selectedProduct = self.tanknames.find(item => item.botnical_name === event.target.value);
                                      if (selectedProduct) {
                                          self.tank.local_name= selectedProduct.marathi_name; 
                                          self.tank.comman_name= selectedProduct.hindi_name;
                                          //self.tank.other_name= selectedProduct.english_name; 
                                          self.tank.botnical_name= selectedProduct.botnical_name; 
                                          
                                          $("#tank_names").val(self.tank.local_name).select2();
                                          $("#c_tank_names").val(self.tank.comman_name).select2(); 
                                           
                                      }
                                    
                            }); 
                            
                             $("#c_tank_names").select2().on('change', function (event) {
                                      
                                    const selectedProduct = self.tanknames.find(item => item.hindi_name === event.target.value);
                                      if (selectedProduct) {
                                          self.tank.local_name= selectedProduct.marathi_name; 
                                          self.tank.comman_name= selectedProduct.hindi_name;
                                          //self.tank.other_name= selectedProduct.english_name; 
                                          self.tank.botnical_name= selectedProduct.botnical_name; 
                                          
                                          
                                          $("#tank_names").val(self.tank.local_name).select2();
                                          $("#b_tank_names").val(self.tank.botnical_name).select2(); 
                                            
                                          //alert(selectedProduct.marathi_name+'---'+selectedProduct.hindi_name+'---'+selectedProduct.botnical_name);
                                      }
                                    
                            }); 
                            
                            
                            
                                 // $("#tank_bot_names").select2();
                    }); 
           }else{
               //self.tanknames  = JSON.parse(getAlltanks()[0]);
               const data_here= await getAlltanks();
               if(data_here.length>0){
                    self.tanknames  = JSON.parse(data_here[0].data);
                     $("#tank_names").select2().on('change', function (event) {
                                    const selectedProduct = self.tanknames.find(item => item.marathi_name === event.target.value);
                                      if (selectedProduct) {
                                          self.tank.local_name= selectedProduct.marathi_name; 
                                          self.tank.comman_name= selectedProduct.hindi_name;
                                          self.tank.other_name= selectedProduct.english_name; 
                                          self.tank.botnical_name= selectedProduct.botnical_name; 
                                      }
                     });
               }
                
               //console.log(data_here[0].data);
           }
        },
      getSurveyQues(servey_id) {
            var self = this;
            const blob = self.dataURLtoBlob(this.photo);
            axios.post('getFrontSurveyQues',{servey_id:servey_id}).then(function (response) {
                self.ques  = response.data.ques ;   
                self.userDetails  = response.data.userDetails ;   
                self.survey_details  = response.data.survey_details ;   
               
            });
        },
        getLocation(){
            navigator.geolocation.getCurrentPosition(this.success, this.error);
        },
        
        error(err) {
            $("#locError").html(err.message);
            this.isLocation=true;
            //this.tank.tank_location_lat=err.message;
            console.log(err);
        }, 
        success(position) {
           // const latitude  = position.coords.latitude;
           // const longitude = position.coords.longitude;
          //  this.tank.tank_location_lat=latitude+","+longitude;
            this.isLocation=true;
            $("#locError").html('');
        },
        
        

        dataURLtoBlob(dataURL) {
             try {
                  const byteString = atob(dataURL.split(',')[1]);
                  const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
                  const ab = new ArrayBuffer(byteString.length);
                  const ia = new Uint8Array(ab);
                  for (let i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                  }
                  return new Blob([ab], { type: mimeString });
             } catch (error) {
                console.error("Error converting dataURL to Blob:", error);
                return null;
              }
        }, 
        setLocation(value){ 
           const latitude  = value.lat;
           const longitude = value.lng;
          this.tank.tank_location_lat=latitude+","+longitude;
           
           this.isLocation=false; 
        },
        backBtnLoc(){  
             this.isLocation=false;
        },
        
        
        
    }
}
</script>
